import React from "react";
import useTheme from "../../../../hooks/useTheme";
import { AppColumn, AppRow } from "../../../UI/Layouts"
import { connect } from "react-redux";
import { openModal, closeModal } from "../../../../redux/Modals/ModalActions";
import { showToast } from "../../../../redux/Snackbar/SnackbarActions";
import { Modal } from "semantic-ui-react";
import { useResponsive } from "../../../UI/ResponsiveContext";
import { AppLinkedText, AppPrimaryButton, CloseCircleButton } from "../../../UI/CustomButtons";
import AppText from "../../../UI/Texts/AppTexts";
import { SizedBox } from "../../../UI/Sizes";
import AppPrimaryTextfield from "../../../UI/TextInput";
import { decodePhoneNumber, normalizePhoneNumber, withOpacity } from "../../../../utils/helperFunctions";

import { useEffect, useState } from "react";
import PhoneInput from "../../../UI/PhoneInput";
import { allPhoneOptions } from "../../../../utils/Constants/dails";

import randomstring from "randomstring";
import { isValidPhoneNumber } from "libphonenumber-js";
import { validateEmail } from "../../../../utils/FieldValidation";
import { QUERY_WORKPLACES } from "../../../../utils/Controller/URLConstants";
import axios from "axios";
import CircularLoader from "../../../UI/LoadingIndicators/CircularLoadingIndicators";
import AppWorkplaceCard from "../../../UI/Cards/WorkplaceCard";
import { t } from "i18next";
import { WorkplaceLogo } from "../../../UI/DisplayImage";

export const AddEditWorkReference = ({
    closeModal,
    referenceData,
    onDone,
    showBottomSaveButton = false,
}) => {
    const theme = useTheme();
    const { isMobile } = useResponsive();

    const [referenceFormData, setReferenceFormData] = useState({
        name: "",
        referenceRole: "",
        email: "",
        phone: "",
        phoneCode: "+46",
    });

    const [workplaceData, setWorkplaceData] = useState({
        workplaceId: "",
        workplaceName: "",
        nameVerksamhet: "",
    });

    const [referenceFormErrors, setReferenceFormErrors] = useState({
        name: null,
        referenceRole: null,
        email: null,
        phone: null,
        workplaceName: null,
    });


    const [workplaceQuery, setWorkplaceQuery] = useState("");
    const [workplaceQueryResults, setWorkplaceQueryResults] = useState([]);

    const [isFetchingWorkplaces, setIsFetchingWorkplaces] = useState(false);


    useEffect(() => {
        if (referenceData) {

            const parsePhoneNumber = decodePhoneNumber(referenceData.phoneNumber);

            if (referenceData.workplaceData) {
                setWorkplaceData(referenceData.workplaceData);
                setWorkplaceQuery(referenceData.workplaceData?.workplaceName ?? "");
            }

            setReferenceFormData({
                name: referenceData.name || "",
                referenceRole: referenceData.referenceRole || "",
                email: referenceData.email || "",
                phone: parsePhoneNumber.local,
                phoneCode: parsePhoneNumber.code,
            });
        }
    }, []);


    const handleSearch = (searchTerm) => {


        if (searchTerm.length < 3) {
            setWorkplaceQueryResults([]);
            return;
        }

        let timer;

        clearTimeout(timer);
        timer = setTimeout(async () => {

            const workplaces = await getQueryWorkPlaces(searchTerm);

            setWorkplaceQueryResults(workplaces);
            setIsFetchingWorkplaces(false);

        }, 800);
    }


    async function getQueryWorkPlaces(query) {
        try {

            if (isFetchingWorkplaces === false) {
                setIsFetchingWorkplaces(true);

                const response = await axios.get(QUERY_WORKPLACES + `?query=${encodeURIComponent(query)}`);
                if (response.data && response.data.status === 0) {
                    const workplaces = response.data.results;

                    setIsFetchingWorkplaces(false);

                    return workplaces;
                }
            }


        } catch (error) {
            console.error("Error fetching workplaces:", error);
        }

        setIsFetchingWorkplaces(false);

        return workplaceQueryResults;
    }



    function updateFormData(key, value) {
        setReferenceFormData(prevData => ({ ...prevData, [key]: value }));
    }

    function updateWorkplaceData(key, value) {
        setWorkplaceData(prevData => ({ ...prevData, [key]: value }));
    }

    function updateFormErrors(key, value) {
        setReferenceFormErrors(prevData => ({ ...prevData, [key]: value }));
    }

    function checkFormFields() {
        let valid = true;
        const { name, referenceRole, email, phone } = referenceFormData;
        const { workplaceName } = workplaceData

        if (name.trim() === "") {
            valid = false;
            updateFormErrors("name", t('add_reference.form.name.error'));
        } else {
            updateFormErrors("name", null);
        }
        if (referenceRole.trim() === "") {
            valid = false;
            updateFormErrors("referenceRole", t('add_reference.form.role.error'));
        } else {
            updateFormErrors("referenceRole", null);
        }
        if (email.trim() === "") {
            valid = false;
            updateFormErrors("email", t('add_reference.form.email.error'));
        } else {
            updateFormErrors("email", null);
        }
        if (workplaceName.trim() === "") {
            valid = false;
            updateFormErrors("workplaceName", t('add_reference.form.workplace.error'));
        } else {
            updateFormErrors("workplaceName", null);
        }
        const fullPhoneNumber = normalizePhoneNumber(referenceFormData.phoneCode, phone);
        const countryCode = allPhoneOptions().find((item) => item.value === referenceFormData.phoneCode);
        const isValid = isValidPhoneNumber(fullPhoneNumber, countryCode?.code, {
            defaultCallingCode: countryCode?.value,
        });
        if (isValid) {
            updateFormErrors("phone", null);
        } else if (phone.length <= 0) {
            valid = false;
            updateFormErrors("phone", t('add_reference.form.phone.error'));
        } else {
            valid = false;
            updateFormErrors("phone", t('add_reference.form.phone.invalid_error'));
        }
        if (!validateEmail(email)) {
            valid = false;
            updateFormErrors("email", t('add_reference.form.email.invalid_error'));
        } else {
            updateFormErrors("email", null);
        }

        return valid;
    }

    function buildReferencePayload(id) {
        return {
            ...(referenceData ?? {}),
            id,
            name: referenceFormData.name.trim(),
            referenceRole: referenceFormData.referenceRole.trim(),
            email: referenceFormData.email.trim(),
            phoneNumber: normalizePhoneNumber(referenceFormData.phoneCode, referenceFormData.phone),
            workplaceData: {
                ...workplaceData,
                workplaceName: workplaceQuery,
            },
        };
    }

    function saveReference() {
        if (!checkFormFields()) return;

        const referenceId = referenceData
            ? referenceData.id
            : randomstring.generate({
                length: 14,
                charset: "alphanumeric",
            });

        onDone(buildReferencePayload(referenceId));
        closeModal();
    }

    function renderSaveButton({ fluid = false, size, style } = {}) {
        return <AppPrimaryButton
            fluid={fluid}
            size={size}
            style={style}
            onClick={saveReference}
        >
            {t('add_reference.form.button.save')}
        </AppPrimaryButton>;
    }

    function renderBottomSaveButton() {
        if (!showBottomSaveButton) return null;

        return <>
            <SizedBox height={theme.spacing.contentElementPadding} />
            {renderSaveButton({ fluid: true })}
        </>;
    }

    const phoneOptions = Array.from(allPhoneOptions());
    const defaultPhoneCode = phoneOptions.find((option) => option.value === referenceFormData?.phoneCode);

    return (<Modal
        centered={true}
        open={true}
        closeOnEscape={true}
        closeOnDimmerClick={true}
        onClose={() => {
            closeModal();
        }}
        basic
        style={{
            margin: "0",
            padding: "0",
            top: "0",
            borderRadius: isMobile ? "0px" : theme.radius.default,
            height: isMobile && "120vh",
            width: isMobile ? "100%" : "50%",
            marginTop: isMobile ? "0px" : theme.spacing.contentPadding,
            marginBottom: isMobile ? "0px" : theme.spacing.contentPaddingBig,
            backgroundColor: theme.colors.white,
            transform: "none",
        }}
    >
        <AppColumn style={{ padding: theme.spacing.contentElementPadding }}>
            <AppRow mainAxisAlignment="space-between" crossAxisAlignment="center" >
                <AppRow crossAxisAlignment="center">
                    <CloseCircleButton
                        onClick={() => {
                            closeModal();
                        }}
                    />
                    <SizedBox width={theme.spacing.elementPadding} />
                    <AppText.BodyText fontWeight={600}>
                        {t('add_reference')}
                    </AppText.BodyText>
                </AppRow>
                {renderSaveButton({
                    size: isMobile ? "medium" : "big",
                    style: {
                        borderRadius: "8px",
                    },
                })}
            </AppRow>

            <SizedBox height={theme.spacing.contentElementPadding} />
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                padding: theme.spacing.elementPadding,
                borderRadius: theme.radius.default,
                backgroundColor: withOpacity(theme.colors.grey, 0.06),
                position: 'relative',
            }}>

                <AppPrimaryTextfield
                    labelText={t('add_reference.form.workplace.placeholder')}
                    hintText={t('add_reference.form.workplace.hint_text')}
                    prefixIcon={'search'}
                    capitalizedText="sentence"
                    value={workplaceQuery}
                    onChange={(value) => {
                        setWorkplaceQuery(value);
                        handleSearch(value);
                    }}
                    error={referenceFormErrors.workplaceName ?? ""}
                    suffixIcon={isFetchingWorkplaces && (<div style={{
                        padding: '0.5rem',
                    }}>
                        <CircularLoader />
                    </div>)}
                />

                {workplaceQueryResults.length > 0 && (
                    <div style={{
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        top: '100px',
                        zIndex: 1000,
                        backgroundColor: theme.colors.white,
                        padding: theme.spacing.elementPadding,
                        borderRadius: theme.radius.default,
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                        maxHeight: '300px',
                        minHeight: '50px',
                        width: '100%',
                        overflowY: 'auto',
                    }}>
                        {workplaceQueryResults.map((workplaceData) => (
                            <AppWorkplaceCard
                                workplaceData={workplaceData}
                                type='search'
                                onClick={() => {

                                    const workplaceId = workplaceData.ivo_id_obj;

                                    const workplaceName = workplaceData.name_obj;
                                    const nameVerksamhet = workplaceData.name_verksamhet;
                                    const orgName = workplaceData.org_name;
                                    const logoUrl = workplaceData.logoUrl;
                                    const orgId = workplaceData.ivo_id_org;

                                    updateWorkplaceData("workplaceId", workplaceId);
                                    updateWorkplaceData("workplaceName", workplaceName);
                                    updateWorkplaceData("nameVerksamhet", nameVerksamhet);
                                    updateWorkplaceData("orgName", orgName);
                                    updateWorkplaceData("logoUrl", logoUrl);
                                    updateWorkplaceData("orgId", orgId);

                                    setWorkplaceQuery(workplaceName);

                                    setWorkplaceQueryResults([]);
                                }} />
                        ))}
                    </div>
                )}

                {workplaceData.workplaceId.trim().length > 0 && <AppRow style={{
                    marginTop: theme.spacing.contentElementPadding,
                }}>
                    <WorkplaceLogo url={workplaceData?.logoUrl} />
                    <SizedBox width={theme.spacing.elementPadding} />
                    <AppColumn style={{
                        flex: 1,
                    }}>
                        <AppText.Caption fontWeight={600}
                            color={theme.primaryColor}>
                            {workplaceData.workplaceName}
                        </AppText.Caption>
                        <SizedBox height={'0.15rem'} />
                        {workplaceData.nameVerksamhet && (
                            <AppText.Footnote>
                                {workplaceData.nameVerksamhet}
                            </AppText.Footnote>
                        )}
                        {workplaceData.orgName && (
                            <AppText.Footnote>
                                {workplaceData.orgName}
                            </AppText.Footnote>
                        )}
                    </AppColumn>
                    <SizedBox width={theme.spacing.elementPadding} />

                </AppRow>}


            </div>
            <SizedBox height={theme.spacing.contentPadding} />
            <AppPrimaryTextfield
                labelText={t('add_reference.form.name.placeholder')}
                hintText={t('add_reference.form.name.hint_text')}
                prefixIcon={'user outline'}
                capitalizedText="word"
                maxLine={1}
                value={referenceFormData.name}
                onChange={(value) => updateFormData("name", value)}
                error={referenceFormErrors.name ?? ""}
            />
            <SizedBox height={theme.spacing.contentElementPadding} />
            <AppPrimaryTextfield
                labelText={t('add_reference.form.role.placeholder')}
                hintText={t('add_reference.form.role.hint_text')}
                prefixIcon={'briefcase'}
                capitalizedText="word"
                maxLine={1}
                value={referenceFormData.referenceRole}
                onChange={(value) => updateFormData("referenceRole", value)}
                error={referenceFormErrors.referenceRole ?? ""}
            />
            <SizedBox height={theme.spacing.contentElementPadding} />
            <AppRow>
                <AppColumn style={{
                    flex: 1,
                }}>
                    <AppPrimaryTextfield
                        labelText={t('add_reference.form.email.placeholder')}
                        hintText={t('add_reference.form.email.hint_text')}
                        prefixIcon={"mail outline"}
                        autoComplete="email"
                        keyboardTextCapitalization={"none"}
                        maxLine={1}
                        value={referenceFormData.email}
                        onChange={(value) => updateFormData("email", value)}
                        error={referenceFormErrors.email ?? ""}
                    />
                </AppColumn>
                {!isMobile && <SizedBox width={theme.spacing.contentElementPadding} />}
                {!isMobile && <AppColumn
                    crossAxisAlignment={"start"}
                    style={{
                        flex: 1,
                    }}>
                    <AppText.Footnote>
                        {t('add_reference.form.phone.placeholder')}
                    </AppText.Footnote>
                    <SizedBox height={theme.spacing.elementPaddingSmall} />
                    <PhoneInput
                        value={referenceFormData?.phone ?? ''}
                        onChange={(value) => updateFormData("phone", value)}
                        onCode={(value) => updateFormData("phoneCode", value)}
                        defaultPhoneCode={defaultPhoneCode}
                        error={referenceFormErrors.phone ?? ""}
                    />
                    {renderBottomSaveButton()}
                </AppColumn>}
            </AppRow>

            {isMobile && <AppColumn style={{
                flex: 1,
            }}>
                <SizedBox height={theme.spacing.contentElementPadding} />
                <AppText.Caption>
                    {"Phone"}
                </AppText.Caption>
                <SizedBox height={theme.spacing.elementPaddingSmall} />
                <PhoneInput
                    value={referenceFormData?.phone ?? ''}
                    onChange={(value) => updateFormData("phone", value)}
                    onCode={(value) => updateFormData("phoneCode", value)}
                    defaultPhoneCode={defaultPhoneCode}
                    error={referenceFormErrors.phone ?? ""}
                />
                {renderBottomSaveButton()}
            </AppColumn>}


            {referenceData && <AppColumn >
                <SizedBox height={theme.spacing.contentPadding} />
                <AppLinkedText
                    text={t('add_reference.form.button.delete')}
                    color={theme.colors.grey}
                    icon={"trash alternate outline"}
                    onClick={() => {
                        closeModal();
                        onDone(referenceData.id);
                    }}
                    underline
                />
            </AppColumn>}
        </AppColumn>

    </Modal >)
}


export default connect(
    null,
    { openModal, closeModal, showToast }
)(AddEditWorkReference);

export const MODAL_ADD_EDIT_REFERENCE = "AddEditWorkReference";
